import { Directive, Input, HostListener, ElementRef } from '@angular/core';
import { ActionMenuService, ActionMenuConfig } from './action-menu.service';
import { ActionMenuOption } from './action-menu.component';

@Directive({
  selector: '[opsActionMenu]',
  standalone: true
})
export class ActionMenuDirective {
  @Input('opsActionMenu') menuId: string = '';
  @Input('optionsFactory') optionsFactory: () => ActionMenuOption[] = () => [];
  @Input('position') position: 'right' | 'left' | 'auto' = 'right';
  @Input('offset') offset: { x: number; y: number } = { x: 0, y: 0 };
  @Input('zIndex') zIndex: number = 1050;
  @Input('allowFlip') allowFlip: boolean = true;

  constructor(
    private elementRef: ElementRef,
    private actionMenuService: ActionMenuService
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
    
    if (!this.menuId) {
      console.warn('opsActionMenu directive requires a menuId');
      return;
    }

    const config: ActionMenuConfig = {
      menuId: this.menuId,
      triggerElement: this.elementRef.nativeElement,
      options: this.optionsFactory(),
      position: this.position,
      offset: this.offset,
      zIndex: this.zIndex,
      allowFlip: this.allowFlip
    };

    this.actionMenuService.toggleActionMenu(config);
  }
} 